(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-prod"] && !window.DesignMode) return;
  try {
    



	$(document).ready(function() {


	// Accordion
	(function ($) {
		$.fn.accordion = function (item, content, openOneItem) {
			if (item == "destroy" && $(this).data('accordion')) {
				$(this).find(this.data("item")).unbind("click");
				$(this).find(this.data("content")).unbind("click").removeAttr('style');
				$(this).removeData('accordion');
			} else if (!$(this).data('accordion')) {
				// General Accordion
				var that = this;
				this.data("item", item);
				this.data("content", content);

				var openOneItem = openOneItem || false;
				$(this).find(item).each(function () {
					$(this).data('top-pos', $(this).offset().top);
				});

				$(this).find(item).click(function (e) {
					if (openOneItem) {
						that.find(item).removeClass(item.substr(1) + '--active');
						that.find(content).slideUp();
					}
					else if ($(this).find(content).is(':hidden') == true) {
						$(this).addClass(item.substr(1) + '--active');
						if (($(window).width() < 769) && ($("body").hasClass("index"))) {
							$("html, body").animate({ scrollTop: $(this).data('top-pos') }, 400);
						}
						$(this).find(content).slideDown();

						$(this).parent().parent().find(item).not($(this)).removeClass(item.substr(1) + '--active');
						$(this).parent().parent().find(item).not($(this)).find(content).slideUp();
					}
					else {
						$(this).removeClass(item.substr(1) + '--active');
						$(this).find(content).slideUp();
					}
					e.preventDefault();
				});
				$(this).find(item + '--active ' + content).show();

				$(this).find(content).click(function (e) {
					e.stopPropagation();
				});
				$(this).data('accordion', true)
			}
		}
	})($);
	$('.accordion').accordion('.accordion__item', '.accordion__item-content');


	// -------------------------- Product Detail Page --------------------------

	// Custom select box
	(function customSelect(){
		$(".custom-select-box__label").click(function(e){
			e.preventDefault();
			$(".custom-select-box__wrap").toggleClass("open");
		});

		$(".custom-select-box__list li").click(function(e){
			e.preventDefault();
			$(".custom-select-box__label").text($(this).clone().children().remove().end().text());
			$(this).parents('form').find("[name='id']").val($(this).data("id"));
			// changeVariant($(this).data("id"));
			$(".custom-select-box__wrap").removeClass("open");
		});

		$(document).on('click', function(e){
			if (!$(e.target).closest(".custom-select-box__label").length) {
				$(".custom-select-box__wrap").removeClass("open");
			}
		});

	})();

	$(".product-intro-wrapper__desc .selectbox select").change(function() {
    $( ".product-intro-wrapper__desc .selectbox select option:selected" ).each(function() {
			$(".product-intro-wrapper__desc .price__discounted-value").text($(this).attr("data-price"));
			if ($(".price__original")) {
				$(".product-intro-wrapper__desc .price__original").text($(this).attr("data-price-original"));
			}
			var currentDiscountPrice = $(this).attr("data-price").split('TL');
			var currentPrice = parseInt(currentDiscountPrice[0].replace(/\,/g,''), 0);
			var discount_15 = Math.ceil((currentPrice / 100) * 25);
			var discount_25 = Math.ceil((currentPrice / 100) * 10);

			$('.discount_15').text(Intl.NumberFormat('en-US').format(currentPrice - discount_15) + 'TL');
			$('.discount_25').text(Intl.NumberFormat('en-US').format(currentPrice - discount_25) + 'TL');
    });
	});

	$('[name="product-color"]').change(function(e){
		var value = $(this).val();
		$('[name="id"]').find('option').remove();
		$("option[data-color='"+value+"']").clone().appendTo('[name="id"]');
		$('[name="id"]').change(function(e){
			var price = $("option[value='"+$(this).val()+"']").data('price');
			$('.product-intro-wrapper__desc form .price .price__original').text(price);
		});
		$('[name="id"]').change();
	});
	$('[name="product-color"]:checked').change();
	// -------------------------------------------------------------------------

	// Career Form
	(function careerForm(){
		$('[name="openPosition"]').change(function(e){
			$('[name="position"]').val($(this).val());

			$('html, body').animate({
				scrollTop: $("#ApplicationForm").offset().top
			}, 1000);
		});

		$('#career-form').submit(function(e){
			if(!$('[name="position"]').val()){
				e.preventDefault();
				alert("Please Select A Position");
			}
		});
	})();


	(function formInputFocus(){
		$('.form-block-wrapper input').focus(function(){
			$(this).parent().addClass('focused');
		});
		$('.form-block-wrapper input').blur(function(){
			var inputValue = $(this).val();
			if ( inputValue == "" ) {
				$(this).parent().removeClass('focused');
			}
		});
		$('.form-block-wrapper input').each(function (i, item) {
			if ($(item).val()) {
				$(item).parent().addClass('focused');
			}
		});
	})();

	$(".selectbox select").change(function(e){
		$(this).parent().parent().find("label").not(':has(".custom-radio"').hide();
		$("#province-wrapper-new").find("label").not(':has(".custom-radio"').hide();
	});



	// TABS - mertdiricanli
	$('.tabs a').click(function(e){
			e.preventDefault();
			$('.tabs a').removeClass('active');
			$(this).addClass('active');
			var tab = $(this).attr('href');
			$('.tabcontent .tab').css('display', 'none');
			$(tab).css('display', 'block');
	});
	
	$('#cart-dynamic').on('click', '.discount-box .dis-option', function(){
		$('.discount-box .dis-option').removeClass('selected');
		$(this).addClass('selected');
		var option = $(this).attr('data-value');
		$('.totals-box li, .totals-box a.primary-button').css('display', 'none');
		$('li'+option).css('display', 'flex');
		$('a.primary-button'+option).css('display', 'block');
	});



});


   $(".faq .pills li").click(function(){
    $(".faq .pills li.active").removeClass("active");
    $(this).addClass("active");
    $("[data-group]").hide();
    $("[data-group='" + $(this).text() + "']").show();
    //$("[data-group='" + $(this).text() + "']").find("article").first().find("h3").click();
  });
  
  $(".faq h3").click(function(){
    if ($(this).parent().hasClass("active")) {
      $(this).parent().removeClass("active");
      return;
    }
    $(this).parent().parent().find(".active").removeClass("active");
    $(this).parent().addClass("active");
  });

  $(".faq .pills li").first().click();
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Prod-Faq"] && !window.DesignMode) return;
  try {
    



	$(document).ready(function() {


	// Accordion
	(function ($) {
		$.fn.accordion = function (item, content, openOneItem) {
			if (item == "destroy" && $(this).data('accordion')) {
				$(this).find(this.data("item")).unbind("click");
				$(this).find(this.data("content")).unbind("click").removeAttr('style');
				$(this).removeData('accordion');
			} else if (!$(this).data('accordion')) {
				// General Accordion
				var that = this;
				this.data("item", item);
				this.data("content", content);

				var openOneItem = openOneItem || false;
				$(this).find(item).each(function () {
					$(this).data('top-pos', $(this).offset().top);
				});

				$(this).find(item).click(function (e) {
					if (openOneItem) {
						that.find(item).removeClass(item.substr(1) + '--active');
						that.find(content).slideUp();
					}
					else if ($(this).find(content).is(':hidden') == true) {
						$(this).addClass(item.substr(1) + '--active');
						if (($(window).width() < 769) && ($("body").hasClass("index"))) {
							$("html, body").animate({ scrollTop: $(this).data('top-pos') }, 400);
						}
						$(this).find(content).slideDown();

						$(this).parent().parent().find(item).not($(this)).removeClass(item.substr(1) + '--active');
						$(this).parent().parent().find(item).not($(this)).find(content).slideUp();
					}
					else {
						$(this).removeClass(item.substr(1) + '--active');
						$(this).find(content).slideUp();
					}
					e.preventDefault();
				});
				$(this).find(item + '--active ' + content).show();

				$(this).find(content).click(function (e) {
					e.stopPropagation();
				});
				$(this).data('accordion', true)
			}
		}
	})($);
	$('.accordion').accordion('.accordion__item', '.accordion__item-content');


	// -------------------------- Product Detail Page --------------------------

	// Custom select box
	(function customSelect(){
		$(".custom-select-box__label").click(function(e){
			e.preventDefault();
			$(".custom-select-box__wrap").toggleClass("open");
		});

		$(".custom-select-box__list li").click(function(e){
			e.preventDefault();
			$(".custom-select-box__label").text($(this).clone().children().remove().end().text());
			$(this).parents('form').find("[name='id']").val($(this).data("id"));
			// changeVariant($(this).data("id"));
			$(".custom-select-box__wrap").removeClass("open");
		});

		$(document).on('click', function(e){
			if (!$(e.target).closest(".custom-select-box__label").length) {
				$(".custom-select-box__wrap").removeClass("open");
			}
		});

	})();

	$(".product-intro-wrapper__desc .selectbox select").change(function() {
    $( ".product-intro-wrapper__desc .selectbox select option:selected" ).each(function() {
			$(".product-intro-wrapper__desc .price__discounted-value").text($(this).attr("data-price"));
			if ($(".price__original")) {
				$(".product-intro-wrapper__desc .price__original").text($(this).attr("data-price-original"));
			}
			var currentDiscountPrice = $(this).attr("data-price").split('TL');
			var currentPrice = parseInt(currentDiscountPrice[0].replace(/\,/g,''), 0);
			var discount_15 = Math.ceil((currentPrice / 100) * 25);
			var discount_25 = Math.ceil((currentPrice / 100) * 10);

			$('.discount_15').text(Intl.NumberFormat('en-US').format(currentPrice - discount_15) + 'TL');
			$('.discount_25').text(Intl.NumberFormat('en-US').format(currentPrice - discount_25) + 'TL');
    });
	});

	$('[name="product-color"]').change(function(e){
		var value = $(this).val();
		$('[name="id"]').find('option').remove();
		$("option[data-color='"+value+"']").clone().appendTo('[name="id"]');
		$('[name="id"]').change(function(e){
			var price = $("option[value='"+$(this).val()+"']").data('price');
			$('.product-intro-wrapper__desc form .price .price__original').text(price);
		});
		$('[name="id"]').change();
	});
	$('[name="product-color"]:checked').change();
	// -------------------------------------------------------------------------

	// Career Form
	(function careerForm(){
		$('[name="openPosition"]').change(function(e){
			$('[name="position"]').val($(this).val());

			$('html, body').animate({
				scrollTop: $("#ApplicationForm").offset().top
			}, 1000);
		});

		$('#career-form').submit(function(e){
			if(!$('[name="position"]').val()){
				e.preventDefault();
				alert("Please Select A Position");
			}
		});
	})();


	(function formInputFocus(){
		$('.form-block-wrapper input').focus(function(){
			$(this).parent().addClass('focused');
		});
		$('.form-block-wrapper input').blur(function(){
			var inputValue = $(this).val();
			if ( inputValue == "" ) {
				$(this).parent().removeClass('focused');
			}
		});
		$('.form-block-wrapper input').each(function (i, item) {
			if ($(item).val()) {
				$(item).parent().addClass('focused');
			}
		});
	})();

	$(".selectbox select").change(function(e){
		$(this).parent().parent().find("label").not(':has(".custom-radio"').hide();
		$("#province-wrapper-new").find("label").not(':has(".custom-radio"').hide();
	});



	// TABS - mertdiricanli
	$('.tabs a').click(function(e){
			e.preventDefault();
			$('.tabs a').removeClass('active');
			$(this).addClass('active');
			var tab = $(this).attr('href');
			$('.tabcontent .tab').css('display', 'none');
			$(tab).css('display', 'block');
	});
	
	$('#cart-dynamic').on('click', '.discount-box .dis-option', function(){
		$('.discount-box .dis-option').removeClass('selected');
		$(this).addClass('selected');
		var option = $(this).attr('data-value');
		$('.totals-box li, .totals-box a.primary-button').css('display', 'none');
		$('li'+option).css('display', 'flex');
		$('a.primary-button'+option).css('display', 'block');
	});



});


   $(".faq .pills li").click(function(){
    $(".faq .pills li.active").removeClass("active");
    $(this).addClass("active");
    $("[data-group]").hide();
    $("[data-group='" + $(this).text() + "']").show();
    //$("[data-group='" + $(this).text() + "']").find("article").first().find("h3").click();
  });
  
  $(".faq h3").click(function(){
    if ($(this).parent().hasClass("active")) {
      $(this).parent().removeClass("active");
      return;
    }
    $(this).parent().parent().find(".active").removeClass("active");
    $(this).parent().addClass("active");
  });

  $(".faq .pills li").first().click();
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Prod-Technical"] && !window.DesignMode) return;
  try {
    

  
 $(".technical .heading").click(function(){
    $(this).parent().toggleClass("active");
  });

	
  

  } catch(e) { console.error(e); }
})();
})();
